export const GET_ALL_DALY_QUIZ_FOR_TODAY = `dailyquiz/GET_ALL_DALY_QUIZ_FOR_TODAY`;
export const SET_ALL_DALY_QUIZ_FOR_TODAY = `dailyquiz/SET_ALL_DALY_QUIZ_FOR_TODAY`;
export const GENERATE_DAILY_QUIZ_FOR_TODAY = `dailyquiz/GENERATE_DAILY_QUIZ_FOR_TODAY`;
